import { Logout } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import type { MouseEventHandler } from "react";

interface UserMenuLogoutRowProps {
  onClick: MouseEventHandler<HTMLDivElement>;
}

/** Última opção do menu — compacta e sem destaque visual. */
export function UserMenuLogoutRow({ onClick }: UserMenuLogoutRowProps) {
  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick(event as unknown as Parameters<MouseEventHandler<HTMLDivElement>>[0]);
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 0.5,
        px: 1,
        py: 0.5,
        mt: 0.25,
        borderRadius: 1.5,
        cursor: "pointer",
        "&:hover": {
          bgcolor: "action.hover",
        },
      }}
    >
      <Logout sx={{ fontSize: 14, color: "text.disabled" }} />
      <Typography
        variant="caption"
        color="text.disabled"
        sx={{ fontSize: "0.75rem", fontWeight: 500, lineHeight: 1.2 }}
      >
        Sair
      </Typography>
    </Box>
  );
}
